import { signal } from "@preact/signals-react";

import Popover from "componentsv2/widgets/Popover";
import { cn } from "tools/ui";

const STYLE_ITEMS_TIME =
  "flex flex-col items-center overflow-y-auto max-h-52 px-2 scroll-style";

const selectedHour = signal("06");
const selectedMinute = signal("00");
const selectedPeriod = signal("AM");

const selected = "bg-neutral-700 text-neutral-100";
const noSelected = "text-neutral-600 hover:bg-blue-100";

const minutes = Array.from({ length: 60 }, (_, i) =>
  String(i).padStart(2, "0"),
);
const hours12 = Array.from({ length: 12 }, (_, i) =>
  String(i + 1).padStart(2, "0"),
);
const periods = ["AM", "PM"];

function styleSelected(data, t) {
  return cn(
    "cursor-pointer px-3 py-1 rounded-md",
    data.value === t ? selected : noSelected,
  );
}

function TimeSelector({ dateTime, show, handleDate }) {
  function onDone() {
    if (dateTime.value) {
      dateTime.value = new Date(dateTime.value);
    }
    if (handleDate) {
      handleDate(dateTime.value, "time");
    }
  }

  function handleClick(data, newValue) {
    if (!dateTime.value) return;

    data.value = newValue;
    let hour = parseInt(selectedHour.value);
    const minute = parseInt(selectedMinute.value);

    if (selectedPeriod.value === "PM" && hour !== 12) {
      hour += 12;
    } else if (selectedPeriod.value === "AM" && hour === 12) {
      hour = 0;
    }
    dateTime.value.setHours(hour);
    dateTime.value.setMinutes(minute);
  }

  return (
    <Popover key="pop-time" name="pop-time" show={show} onDone={onDone}>
      <div className="bg-white rounded-lg w-fit">
        <div className="grid grid-cols-3 gap-x-2 bg-neutral-100 py-2 text-center text-xs text-neutral-500 mb-1">
          <span className="">Hours</span>
          <span className="">Minutes</span>
          <span className="">AM/PM</span>
        </div>
        <div className="grid grid-cols-3 gap-2 overflow-hidden max-h-52">
          <div className={STYLE_ITEMS_TIME}>
            {hours12.map((h) => (
              <div
                key={h}
                className={styleSelected(selectedHour, h)}
                onClick={() => handleClick(selectedHour, h)}
              >
                {h}
              </div>
            ))}
          </div>
          <div className={STYLE_ITEMS_TIME}>
            {minutes.map((m) => (
              <div
                key={m}
                className={styleSelected(selectedMinute, m)}
                onClick={() => handleClick(selectedMinute, m)}
              >
                {m}
              </div>
            ))}
          </div>
          <div className={STYLE_ITEMS_TIME}>
            {periods.map((p) => (
              <div
                key={p}
                className={styleSelected(selectedPeriod, p)}
                onClick={() => handleClick(selectedPeriod, p)}
              >
                {p}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Popover>
  );
}

export default TimeSelector;
